export interface IImageGenerationDataModel {
    bucket: string;
    created_at: string;
    created_by: string;
    filename: string;
    model_name: string;
    oe_reference_image: string;
    pk: string;
    prompt: string;
    sk: string;
    status: string;
    ta_reference_image: string;
    output_image: string;
    feedback_rating: number | null;
    feedback_text: string | null;
    usage: string;
}

export const defaultPromptWithReferencePair: string = `Convert the CONTENT IMAGE into a technical line-art drawing that matches the visual style of the STYLE REFERENCE.

IMAGE ROLES:
- 'reference_oem_image.png' — ORIGINAL STYLE REFERENCE (before). Shows the original photographic style that will be transformed away.
- 'reference_ta_image.png' — TARGET STYLE REFERENCE (after). Shows the desired line-art style to apply. Study its line weight, stroke type, background colour, and level of detail.
- 'oem_image_to_process.png' — CONTENT IMAGE. Convert this into line-art. Keep all components and their layout. Do not add or remove any component.

STYLE TRANSFORMATION (primary goal):
- Output must look like a technical line-art drawing, NOT a photograph or sketch.
- Clean, sharp, uniform strokes — like Adobe Illustrator vector paths.
- White background, no photographic textures, no shading, no gradients.
- Consistent line weight matching the STYLE REFERENCE.
- Remove number labels, dimension lines, and annotation symbols.

STROKE QUALITY:
- Every stroke must close into a complete shape or meet another stroke.
- No dangling ends, orphaned curves, or floating fragments.
`

export const defaultPromptNoReference: string = `Convert the input image into a clean technical line-art drawing.

STYLE (primary goal):
- Output must look like a technical line-art drawing, NOT a photograph or sketch.
- Clean, sharp, uniform strokes — like Adobe Illustrator vector paths.
- White background, no photographic textures, no shading, no gradients.
- Consistent line weight throughout.
- Remove number labels, dimension lines, and annotation symbols.

CONTENT CONSTRAINT:
- Reproduce the same components and spatial layout visible in the input image.
- Do not add or remove any component.

STROKE QUALITY:
- Every stroke must close into a complete shape or meet another stroke.
- No dangling ends, orphaned curves, or floating fragments.
`